<div class="row g-4 mb-4" [class.placeholder-glow]="isLoading()">
    <!-- Open Column -->
    <div class="col-12 col-md-4 text-center">
        <div class="h-100 pe-md-3 border-md-end">
            @if (isLoading()) {
                <div class="placeholder col-4 mb-3"></div>
                <div class="placeholder col-6 mb-2 placeholder-amount"></div>
                <div class="placeholder col-5"></div>
            } @else {
                <h5 class="text-primary fw-semibold mb-3">Open</h5>
                <div class="fs-3 fw-bold text-primary">{{ summary()?.totalOpenAmount! | CurrencyDisplay: summary()?.currency! }}</div>
                <div class="text-muted">{{ summary()?.openChargesCount | number }} invoice(s)</div>
            }
        </div>
    </div>

    <!-- Paid Column -->
    <div class="col-12 col-md-4 text-center">
        <div class="h-100 px-md-3 border-md-end">
            @if (isLoading()) {
                <div class="placeholder col-4 mb-3"></div>
                <div class="placeholder col-6 mb-2 placeholder-amount"></div>
                <div class="placeholder col-5"></div>
            } @else {
                <h5 class="text-success fw-semibold mb-3">Paid</h5>
                <div class="fs-3 fw-bold text-success">{{ summary()?.totalPaidAmount! | CurrencyDisplay: summary()?.currency! }}</div>
                <div class="text-muted">{{ summary()?.paidChargesCount | number }} invoice(s)</div>
            }
        </div>
    </div>

    <!-- Late Column -->
    <div class="col-12 col-md-4 text-center">
        <div class="h-100 ps-md-3">
            @if (isLoading()) {
                <div class="placeholder col-4 mb-3"></div>
                <div class="placeholder col-6 mb-2 placeholder-amount"></div>
                <div class="placeholder col-5"></div>
            } @else {
                <h5 class="text-danger fw-semibold mb-3">Late</h5>
                <div class="fs-3 fw-bold text-danger">{{ summary()?.totalLateAmount! | CurrencyDisplay: summary()?.currency! }}</div>
                <div class="text-muted">{{ summary()?.lateChargesCount | number }} invoice(s)</div>
            }
        </div>
    </div>
</div>
